<section class="water-theme">
  <header class="mat-elevation-z8 common-header">
    <app-navigation></app-navigation>
  </header>
  <main class="app-content mat-elevation-z0">
    <router-outlet></router-outlet>
  </main>
</section>